import React from 'react'
import clsx from 'clsx'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'

import MarkdownLink from '../../atoms/MarkdownLink'
import Code from './Code'

import useStyles from './styles'
import Blockquote from './Blockquote'

const mdProps = {
  remarkPlugins: [remarkGfm],
  rehypePlugins: [rehypeRaw],
  components: {
    pre: 'p',
    code: ({ children, inline }) => <Code inline={inline}>{children}</Code>,
    h2: 'p',
    h1: 'p',
    a: MarkdownLink,
    blockquote: ({ children }) => <Blockquote children={children} />,
    ul: ({ children }) => (
      <ul style={{ margin: 0, whiteSpace: 'normal' }}>{children}</ul>
    ),
    ol: ({ children }) => (
      <ol style={{ margin: 0, whiteSpace: 'normal' }}>{children}</ol>
    )
  }
}

const Markdown = ({ children, className = undefined, ...props }) => {
  const classes = useStyles()

  return (
    <ReactMarkdown
      linkTarget='_blank'
      {...mdProps}
      className={clsx(classes.root, className)}
      skipHtml={true}
      {...props}
    >
      {children}
    </ReactMarkdown>
  )
}

export default Markdown
